<ng-container *transloco="let tr; prefix: 'promoBanners'; scope: 'promo-banners'">
  <form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-skeleton [nzActive]="true" *ngIf="isLoading.files"></nz-skeleton>
        <div class="clearfix" *ngIf="!isLoading.files">
          <nz-upload
            nzListType="picture"
            class="upload-list-inline"
            [(nzFileList)]="fileList"
            [nzAction]="filesUploadUrl"
            [nzMultiple]="false"
            [nzDownload]="fileDownloadFn"
            [nzHeaders]="fileUploadHeadersFn"
            (nzChange)="handleFileUploadStatusChanged($event)"
            [nzPreview]="handlePreviewFn">
            <button type="button" nz-button *ngIf="fileList.length === 0">
              <span><i nz-icon nzType="upload"></i> {{'button.upload' | transloco}}</span>
            </button>
          </nz-upload>
          <span>
            <nz-alert [nzMessage]="'modal.photoSize' | transloco"></nz-alert>
          </span>
        </div>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('language')}}</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="lang">
              @for (lang of langs; track lang;) {
                <nz-option [nzValue]="lang" [nzLabel]="lang"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('story.form.url')}}</nz-form-label>
          <nz-form-control>
            <input nz-input type="text" formControlName="url">
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('story.form.type')}}</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="type">
              <nz-option nzValue="image" nzLabel="Image"></nz-option>
              <nz-option nzValue="video" nzLabel="Video"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label>{{tr('story.form.actionUrl')}}</nz-form-label>
          <nz-form-control>
            <input nz-input type="text" formControlName="actionUrl">
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label>{{tr('story.form.actionButton')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="actionButton"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon class="m-top-1rem"></nz-alert>
  </form>
</ng-container>

<div *nzModalFooter>
  <button (click)="modalRef.close()" nz-button nzType="default">{{ 'button.cancel' | transloco }}</button>
  <button [disabled]="form.pristine || isLoading.save || form.invalid" [nzLoading]="isLoading.save" (click)="submitForm()" nz-button nzType="primary">{{ 'button.save' | transloco }}</button>
</div>

